<template>
  <div>
    <div class="c-recipe-box-widget">
      <div class="c-recipe-box-widget__header c-label c-label--red c-label--wide">
        <h3 class="c-recipe-box-widget__heading h6">{{ translations.firstSectionTitle }}</h3>
        <a
          href="#"
          role="button"
          aria-label="Edit Folder"
          title="Edit Folder"
          class="c-recipe-box-widget__edit c-cta h-color--white"
          v-on:click="showEditSection"
        >{{ translations.editText }}</a>
      </div>
      <nav class="c-recipe-box-widget__content">
        <ul class="c-recipe-box-categories">
          <li>
            <a
              :href="translations.currentItemLink"
              class="c-recipe-box-categories__link"
            >{{ translations.label }}</a>
          </li>
          <li v-for="option in folderitems" v-bind:key="option.text">
            <a
              v-if="option.count!=null"
              :href="translations.currentItemLink + '?recipeFolder=' + option.text"
              class="c-recipe-box-categories__link"
            >{{option.text}} ({{option.count}})</a>
            <a
              v-if="option.count==null"
              :href="translations.currentItemLink + '?recipeFolder=' + option.text"
              class="c-recipe-box-categories__link"
            >{{option.text}}</a>
          </li>
        </ul>
      </nav>
    </div>
    <div
      id="recipeboxeditsection"
      ref="recipeboxeditsection"
      class="c-recipe-box-widget"
      v-show="isOpen"
      role="document"
      tabindex="-1"
    >
      <div class="c-recipe-box-widget__header c-label c-label--red c-label--wide">
        <h3 class="c-recipe-box-widget__heading h6">{{ translations.firstSectionTitle }}</h3>
      </div>
      <div ref="folderEditSection" class="c-recipe-box-widget__content clearfix">
        <form id="updateRecipeboxFormData" @submit.prevent="SumbitUpdateRecipeBox" action="#">
          <ul
            id="recipeBoxUpdate"
            ref="recipeBoxUpdate"
            class="c-recipe-box-categories update-recipe-section"
          >
            <li
              id="recipeBoxUpdateMessage"
              ref="recipeBoxUpdateMessage"
              :hidden="true"
              aria-live="polite"
              role="alert"
              class="sr-only"
            ></li>
            <li class="form-group">{{ translations.label }}</li>
            <li class="form-group" v-for="option in items" v-bind:key="option.text">
              <label class="sr-only" v-bind:for="option.text | underscore">{{option.text}}</label>

              <div class="input-group">
                <input
                  class="form-control has-invalid-icon"
                  v-bind:id="option.text | underscore"
                  type="text"
                  :value="option.text"
                  name="updateFolder"
                  :title="option.text"
                />
                <a
                  href="#"
                  class="input-validation-icon input-validation-icon--invalid"
                  aria-label="Delete Folder"
                  title="Delete Folder"
                  v-on:click="DeleteFolder(option.text)"
                  role="button"
                >
                  <i class="icon-times"></i>
                </a>
              </div>
            </li>
          </ul>
          <input
            type="submit"
            :value="translations.saveButtonText"
            class="c-recipe-box-widget__submit btn btn-danger btn-round"
          />
        </form>
      </div>
    </div>

    <div class="c-recipe-box-widget">
      <div class="c-recipe-box-widget__header c-label c-label--red c-label--wide">
        <h3 class="c-recipe-box-widget__heading h6">{{translations.createNewFolder}}</h3>
      </div>

      <div class="c-recipe-box-widget__content clearfix">
        <p class="sr-only" ref="createFolderError" :hidden="true" role="alert"></p>
        <form :class="[wasSubmitted ? 'was-validated' : 'needs-validation']" action="#" novalidate>
          <ul class="c-recipe-box-categories">
            <li class="form-group">
              <label for="create-new-folder">
                New Folder Name <span aria-hidden="true">*</span>
              </label>
              <input
                ref="createFolderInput"
                class="form-control"
                :class="isValid ? ' ' : 'is-invalid'"
                :aria-atomic="isValid"
                :aria-invalid="!isValid"
                required
                id="create-new-folder"
                type="text"
                :placeholder="translations.newFolderName"
                name
                v-model.trim="fieldValue"
              />
              <div 
                role="alert"
                aria-atomic="true"
                class="form-text text-danger is-invalid h4"
                id="new-folder-help"
                v-if="!isValid"
              > 
                <small>A folder name is required.</small>
              </div>
            </li>
          </ul>

          <input
            type="submit"
            :disabled="fieldValue === ''"
            :value="translations.createButtonText"
            class="c-recipe-box-widget__submit btn btn-danger btn-round"
            @click.prevent="createFolderFn"
          />
        </form>
      </div>
    </div>
    <div
      v-bind:class="{ 'loading-image modal fade show d-block': loadingImageShow }"
      v-if="loadingImageShow"
      v-show="loadingImageShow"
    >
      <div class="loader-centered">
        <img src="~/assets/images/ajax-loading.gif" alt />
      </div>
      <div id="recipe-add-to-box___BV_modal_backdrop__jlf62in2" class="modal-backdrop fade show"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  filters: {
    underscore: function(value) {
      if (!value) return "";
      value = value.toString();
      return "edit_" + value.split(" ").join("_");
    }
  },
  props: {
    translations: {
      type: Object,
      required: true
    },
    endpointDeleteRecipe: {
      type: String,
      default: "/aha-service/RecipeBox/DeleteRecipeBox"
    },
    endpointRecipeListing: {
      type: String,
      default: "/aha-service/RecipeBox/RecipeBoxListing"
    },
    endpointCreateFolder: {
      type: String,
      default: "/aha-service/RecipeBox/CreateRecipeBoxFolder"
    },
    endpointUpdateFolders: {
      type: String,
      default: "/aha-service/RecipeBox/SaveRecipe"
    },
    errorMessage: {
      type: String,
      default: "Error loading Recipe Box Folder"
    },
    folderitems: {
      type: Array
    },
    items: {
      type: Array
    },
    message: {
      type: String,
      default: " "
    }
  },
  data() {
    return {
      recipeBoxUpdate: null,
      recipeBoxUpdateMessage: null,
      fieldValue: '',
      createFolderError: null,
      folderEditSection: null,
      isOpen: false,
      loadingImageShow: false,
      updateFolder: [],
      updateFolderError: null,
      recipeboxeditsection: null, 
      isValid: true, 
      wasSubmitted: false
    };
  },
  methods: {
    DeleteFolder(folderName) {
      this.loadingImageShow = true;
      axios({
        method: "post",
        url: this.$props.endpointDeleteRecipe,
        responseType: "json",
        data: {
          folderName: folderName
        }
      })
        .then(response => {
          console.log(response.data);
          this.$props.items = response.data.JsonItemsDefaultFolders;
          this.$refs.recipeBoxUpdateMessage.removeAttribute("hidden");
          this.$refs.recipeBoxUpdateMessage.innerHTML = response.data.Message;
          this.getRecipeListing();
          this.loadingImageShow = false;
        })
        .catch(error => {
          this.loadingImageShow = false;
          this.recipeBoxUpdate = `
                        <div class="alert alert-danger" role="alert">
                            ${this.$props.errorMessage}
                        </div>
                    `;

          // eslint-disable-next-link
          console.log(error);
        });
    },
    getRecipeListing() {
      axios({
        method: "post",
        url: this.$props.endpointRecipeListing,
        responseType: "json"
      })
        .then(response => {
          console.log(response.data);
          this.$props.folderitems = response.data.JsonItemsAllFolders;
          this.$props.items = response.data.JsonItemsDefaultFolders;
        })
        .catch(error => {
          this.recipeBoxUpdate = `
                        <div class="alert alert-danger" role="alert">
                            ${this.$props.errorMessage}
                        </div>
                    `;

          // eslint-disable-next-link
          console.log(error);
        });
    },
    createFolderFn() {

      if(this.fieldValue && this.fieldValue !== ''){
        this.isValid = true; 
        this.loadingImageShow = true;
        axios({
          method: "post",
          url: this.$props.endpointCreateFolder,
          responseType: "text",
          data: {
            folderName: this.fieldValue
          }
      }) .then(response => {
          console.log(response.data);
          this.$refs.createFolderError.removeAttribute("hidden");
          this.$refs.createFolderError.innerHTML = response.data;
          this.getRecipeListing();
          this.loadingImageShow = false;
        }) .catch(error => {
          this.loadingImageShow = false;
          this.recipeBoxUpdate = `
              <div class="alert alert-danger" role="alert">
                  ${this.$props.errorMessage}
              </div>
          `;
          // eslint-disable-next-link
          console.log(error);
        });
      } else {
        this.isValid = false; 
        this.$refs.createFolderInput.focus();
      }
      this.wasSubmitted = true;
      this.fieldValue = ''; 
    },
    SumbitUpdateRecipeBox(evt) {
      this.updateFolder = evt.target.elements.updateFolder.value;
      var inputLists = evt.target.elements.updateFolder;
      var arra = {};
      if (evt.target.length > 2) {
        inputLists.forEach(element => {
          if (element.value != element._value) {
            arra[element._value] = element.value;
          }
        });
      } else {
        if (inputLists.value != inputLists._value) {
          arra[inputLists._value] = inputLists.value;
        }
      }

      this.loadingImageShow = true;
      axios({
        method: "post",
        url: this.$props.endpointUpdateFolders,
        responseType: "text",
        data: {
          formData: arra
        }
      })
        .then(response => {
          console.log(response.data);
          this.$refs.updateFolderError.removeAttribute("hidden");
          this.$refs.updateFolderError.innerHTML = response.data;
          this.getRecipeListing();
          this.loadingImageShow = false;
        })
        .catch(error => {
          this.loadingImageShow = false;
          this.recipeBoxUpdate = `
                        <div class="alert alert-danger" role="alert">
                            ${this.$props.errorMessage}
                        </div>
                    `;

          // eslint-disable-next-link
          console.log(error);
        });
    },
    showEditSection() {
      if (this.isOpen == true) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
        this.focusRef(this.$refs.recipeboxeditsection);
      }
    },
    focusRef(ref) {
      this.$nextTick(() => {
        this.$refs.recipeboxeditsection.focus();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/app/components/aha-modify-recipe-box.vue